import { gql } from "@apollo/client"

const DownloadLinkFields = gql`
  fragment DownloadLinkFields on DownloadLink {
    url
    base64
    contentType
    title
    createdAt
    byteSize
    filename
    documentId
    __typename
  }
`

export default DownloadLinkFields
